import { cn } from '@/lib/utils';

// Skeleton loader component
export function Skeleton({ className, ...props }) {
  return (
    <div
      className={cn('skeleton animate-pulse bg-muted rounded', className)}
      {...props}
    />
  );
}

// Event card skeleton - compact 16:9 layout
export function EventCardSkeleton() {
  return (
    <div className="bg-white rounded-lg border border-border overflow-hidden animate-fade-in">
      <Skeleton className="aspect-video w-full rounded-t-lg rounded-b-none" />
      <div className="p-3 space-y-2">
        <Skeleton className="h-4 w-16 rounded-full" />
        <Skeleton className="h-5 w-3/4" />
        <div className="space-y-1">
          <Skeleton className="h-3 w-1/2" />
          <Skeleton className="h-3 w-1/3" />
        </div>
        <div className="flex justify-between items-center pt-2 border-t border-border">
          <Skeleton className="h-6 w-14" />
          <Skeleton className="h-7 w-16 rounded-lg" />
        </div>
      </div>
    </div>
  );
}

// Ticket card skeleton
export function TicketCardSkeleton() {
  return (
    <div className="bg-white rounded-2xl border border-border p-4 animate-fade-in">
      <div className="flex gap-4">
        <Skeleton className="h-24 w-24 rounded-xl flex-shrink-0" />
        <div className="flex-1 space-y-2">
          <Skeleton className="h-5 w-3/4" />
          <Skeleton className="h-4 w-1/2" />
          <Skeleton className="h-4 w-1/3" />
          <Skeleton className="h-6 w-20 rounded-full" />
        </div>
      </div>
    </div>
  );
}

// List skeleton
export function ListSkeleton({ count = 3, ItemSkeleton = EventCardSkeleton }) {
  return (
    <div className="space-y-4">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className={`stagger-${i + 1}`} style={{ animationFillMode: 'both' }}>
          <ItemSkeleton />
        </div>
      ))}
    </div>
  );
}

// Page skeleton with header
export function PageSkeleton({ showHeader = true }) {
  return (
    <div className="min-h-screen bg-background animate-fade-in">
      {showHeader && (
        <div className="bg-white border-b border-border p-4">
          <div className="flex items-center justify-between">
            <Skeleton className="h-10 w-32" />
            <Skeleton className="h-10 w-10 rounded-full" />
          </div>
        </div>
      )}
      <div className="p-4 space-y-4">
        <Skeleton className="h-8 w-48" />
        <ListSkeleton count={3} />
      </div>
    </div>
  );
}

export default Skeleton;
